import React from 'react'
import { MODULE_KEYS, CONCIERGE_BANNER_DEFAULTS } from '../../moduleRegistry'
import { usePersonalizedModuleConfig } from '../../personalization/usePersonalizedModuleConfig'
import { Greeting } from './Greeting'
import { GreetingSteps } from './GreetingSteps'

import '../../styles/ConciergeModule/ConciergeModule.scss'

export const ConciergeModule = () => {
  const { heading, subheading, listOfSteps, image, mobile } = usePersonalizedModuleConfig(MODULE_KEYS.conciergeBanner, CONCIERGE_BANNER_DEFAULTS)

  return <div className="concierge-module">
      <Greeting
          image={image}
          heading={heading}
          headingFallback={CONCIERGE_BANNER_DEFAULTS.heading}
          subheading={subheading}
          subheadingFallback={CONCIERGE_BANNER_DEFAULTS.subheading}
          mobileSubheading={mobile.subheading}
        />
      <GreetingSteps steps={listOfSteps} toggleText={mobile.toggleText} />
    </div>
}
